import {FlowConfigInterface} from 'app/components/onboardingFlows/flows/common/FlowConfigInterface';
import LocalStorageManager from 'app/services/web-storage/LocalStorageManager';
import {useNative} from 'app/contexts/NativeContext';

const DAY_IN_MINUTES = 24 * 60;
abstract class FlowConfigAbstract implements FlowConfigInterface {
  public abstract readonly id: string;
  public abstract readonly title: string;
  public abstract readonly description: string;
  public abstract readonly animationSrc: string;
  protected abstract readonly start_time: Date;
  protected abstract readonly available_until: Date;
  protected abstract readonly reshowInDays: number | null;

  public abstract isAllowedToDisplay(): boolean;

  public handleOnClose(): void {
    this.setViewed();
  }

  private isAvailable(): boolean {
    const currentTime = new Date();
    return currentTime < this.available_until && currentTime > this.start_time;
  }

  private getStoreKey(): string {
    return `onboarding_flow_id_${this.id}_viewed`;
  }

  private isViewed(): boolean {
    const item = LocalStorageManager.getInstance().getItem(this.getStoreKey());
    return !!item;
  }

  protected isAvailableAndNotViewed(): boolean {
    return this.isAvailable() && !this.isViewed();
  }

  private setViewed(): void {
    const expiresIn = this.reshowInDays ? this.reshowInDays * DAY_IN_MINUTES : this.available_until;
    LocalStorageManager.getInstance().setItem(this.getStoreKey(), true, expiresIn);
  }

  protected isNative(): boolean {
    const nativeInfo = useNative();
    if (!nativeInfo) {
      return false;
    }

    return nativeInfo.isNativeApp;
  }

  protected isSupportedNativeVersion(minVersion: string): boolean {
    const nativeInfo = useNative();
    if (!nativeInfo) {
      return false;
    }

    const {isNativeApp, buildInfo} = nativeInfo;
    if (!isNativeApp) {
      return false;
    }

    // Flutter: ios and android are using same version, so we can check it directly
    return buildInfo.version >= minVersion;
  }
}

export default FlowConfigAbstract;
